import { Injectable } from '@angular/core';

const TOKEN_KEY = 'auth-token';
const nextTOKEN_KEY = 'ses-token';
const fbTOKEN_KEY = 'fb-token';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor() {}

  public saveToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public deleteToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  public savenextToken(token: string) {
    localStorage.setItem(nextTOKEN_KEY, token);
  }

  public getnextToken(): string {
    return localStorage.getItem(nextTOKEN_KEY);
  }

  public deletenextToken(): void {
    localStorage.removeItem(nextTOKEN_KEY);
  }

  public saveTokenFB(token: string) {
    localStorage.setItem(fbTOKEN_KEY, token);
  }

  public getTokenFB(): string {
    return localStorage.getItem(fbTOKEN_KEY);
  }

  public deleteTokenFB(): void {
    localStorage.removeItem(fbTOKEN_KEY);
  }
}
